export interface SellerPlatformFeesInterface {
    feesPercent: number;
    maxCap?: number | null;
}

export interface SellerPlanInterface {
    id: string;
    name: string;
    description?: string;
    sellerPlatformFees: SellerPlatformFeesInterface;
    termsAndConditions?: string[];
    isActive: boolean;
    billingCycle?: string;
    price?: number;
    maxGigsAllowed?: number | null;
    maxOrdersPerMonth?: number | null;
    prioritySupport?: boolean;
    features?: string[];
    createdAt?: Date;
    updatedAt?: Date;
}

export class SellerPlan implements SellerPlanInterface {
    id: string;
    name: string;
    description?: string;
    sellerPlatformFees: SellerPlatformFeesInterface;
    termsAndConditions?: string[];
    isActive: boolean;
    billingCycle?: string;
    price?: number;
    maxGigsAllowed?: number | null;
    maxOrdersPerMonth?: number | null;
    prioritySupport?: boolean;
    features?: string[];
    createdAt?: Date;
    updatedAt?: Date;

    public constructor(jsonData: any) {
        this.id = jsonData._id;
        this.name = jsonData.name;
        this.description = jsonData.description;
        this.sellerPlatformFees = jsonData.sellerPlatformFees as SellerPlatformFeesInterface;
        this.termsAndConditions = jsonData.termsAndConditions;
        this.isActive = jsonData.isActive;
        this.billingCycle = jsonData.billingCycle;
        this.price = jsonData.price;
        this.maxGigsAllowed = jsonData.maxGigsAllowed;
        this.maxOrdersPerMonth = jsonData.maxOrdersPerMonth;
        this.prioritySupport = jsonData.prioritySupport;
        this.features = jsonData.features;
        this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
        this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
    }
}
